import { SafeArea } from "antd-mobile";
import { FC, ReactNode } from "react";
import styled from "styled-components";

interface IProps {
  appContent: ReactNode;
}

const AppBaseLayout: FC<IProps> = ({ appContent }) => {
  return (
    <Container>
      <SafeArea position="top" />
      <Content>
        {appContent}
      </Content>
      <SafeArea position="bottom" />
    </Container>
  );
};

export default AppBaseLayout;

const Container = styled.div`
  width: 100%;
  height: 100dvh;
  display: flex;
  flex-direction: column;
  min-height: 0;
`;

const Content = styled.div`
  flex: 1;
  min-height: 0;
  overflow: hidden;
`;
